import {secured as axios, nextcloud as nextCloudAxios} from '../../../axios';
import {imageAutoCompress} from '../../helper/image';

export class Event {
  static async getEvent(eventId) {
    const res = await axios.get(`/event/${eventId}`);
    return res.data;
  }

  static async joinEvent(eventId) {
    const res = await axios.post(`/event/${eventId}/join`);
    return res.data;
  }

  static async leaveEvent(eventId) {
    const res = await axios.delete(`/event/${eventId}/leave`);
    return res.data;
  }

  static async sendEvent(
    eventName,
    eventPlace,
    eventDetail,
    dateStart,
    dateEnd,
    image,
    communityId,
  ) {
    const compressedImage = await imageAutoCompress(image.file);

    const res = await axios.post(`/community/${communityId}/event`, {
      title: eventName,
      description: eventDetail,
      position: eventPlace,
      image: {
        name: image.file.name,
        type: image.file.type,
        base64: compressedImage.base64,
      },
      published_date: {
        start: dateStart,
        end: dateEnd,
      },
    });
    return res.status;
  }

  static async getEvents(communityId) {
    const res = await axios.get(`/community/${communityId}/events`);
    return res.data;
  }

  static async syncCreateEvent(body, userId, token, eventId) {
    return await nextCloudAxios.put(
      `/remote.php/dav/calendars/${userId}/personal-${userId}.ics/${eventId}-${userId}.ics`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'text/calendar',
          Accept: '*/*',
        },
      },
    );
  }

  static async syncDeleteEvent(eventName, userId, token) {
    try {
      await nextCloudAxios.delete(
        `/remote.php/dav/calendars/${userId}/personal-${userId}.ics/${eventName}.ics`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'text/calendar',
            Accept: '*/*',
          },
        },
      );
    } catch (err) {
      console.log(err);
    }
    return;
  }

  static async makeMKCalendarRequest(token, userId) {
    const url = `/remote.php/dav/calendars/${userId}/personal-${userId}.ics`;
    const body =
      '<C:mkcalendar xmlns:D="DAV:" xmlns:C="urn:ietf:params:xml:ns:caldav" xmlns:ical="http://apple.com/ns/ical/"><D:set><D:prop><D:displayname>Personal</D:displayname><ical:calendar-color>cal Color</ical:calendar-color></D:prop></D:set></C:mkcalendar>';
    const headers = {
      Authorization: `Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/xml',
    };
    const response = await nextCloudAxios({
      method: 'MKCALENDAR',
      url,
      data: body,
      headers,
    });
    console.log(response);
  }

  static async getPersonalCalendar(token, userId) {
    const response = await nextCloudAxios
      .get(
        `/remote.php/dav/calendars/${userId}/personal-${userId}.ics?export&accept=jcal`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'text/calendar',
            Accept: '*/*',
          },
        },
      )
      .then(res => res)
      .catch(res => res);

    if (response?.status === 404) {
      return false;
    } else {
      return true;
    }
  }
}
